import { render, staticRenderFns } from "./CustomerTextInput.vue?vue&type=template&id=172d56e6&scoped=true&lang=pug&"
import script from "./CustomerTextInput.vue?vue&type=script&lang=js&"
export * from "./CustomerTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d56e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172d56e6')) {
      api.createRecord('172d56e6', component.options)
    } else {
      api.reload('172d56e6', component.options)
    }
    module.hot.accept("./CustomerTextInput.vue?vue&type=template&id=172d56e6&scoped=true&lang=pug&", function () {
      api.rerender('172d56e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/forms/CustomerTextInput.vue"
export default component.exports